import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { baseUrl } from "../Services/baseUrl";

export const useFetchData = (endpoint, queryKey, options = {}, isPost = false, data = {}, refetch = true) => {
    const accessToken = window.localStorage.getItem('token')
    console.log("accessToken---->", accessToken)
    return useQuery({
      queryKey: [queryKey],
      queryFn: async () => {
        try {
          const response = await axios({
            method: isPost ? "POST" : "GET", // Correctly use `isPost`
            url: `${baseUrl.replace(/\/$/, "")}/${endpoint.replace(/^\//, "")}`, // Append the `url` to the `baseURL`
            data: isPost ? data : {}, // Use the `data` parameter for POST requests
            headers: {
              "tymeplusjwt": accessToken, 
            },
          });
          return response.data;
        } catch (err) {
          // Handle errors gracefully
          console.error("Error in API request", err);
          return err.response ? err.response : { error: "An unknown error occurred" };
        }
      },
      refetchOnWindowFocus: false, // Disable refetching when window refocuses (you can change this as needed)
      refetch,
      ...options, // Apply any additional options passed to the hook
    });
  };
  
